import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.text.Component,
    ds.overlay.confirmation.Component,
  ],
  selector: 'atn-scenario-delete-dialog',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.routeBound.scenarios.Feature} */
  public readonly scenariosFeature = ngCore.inject(
    state.routeBound.scenarios.Feature,
  )

  /** Submit changes handler */
  public confirmClickHandler() {
    this.scenariosFeature.actions.submitDelete
      .from('DeleteScenarioDialog.DeleteButton.Clicked')
      .dispatch()
  }

  /** Discard changes handler */
  public cancelClickHandler() {
    this.scenariosFeature.actions.cancelDelete
      .from('DeleteScenarioDialog.CancelButton.Clicked')
      .dispatch()
  }
}
